import { connectStorageAccess } from './connectStorageAccess';
import StorageAccess from './StorageAccess';

export const ConnectedStorageAccess = connectStorageAccess(StorageAccess);
